class Locale {
  detectCurrent() {
    if (window.navigator.languages) {
      return window.navigator.languages[0]
    } else {
      return window.navigator.userLanguage || window.navigator.language
    }
  }
}
const locale = new Locale()
export default locale
